const state = {
    data: []
}

const mutations = {
    storeStockCatalogs (state, payload) {
        state.data = payload
    },
    storeStockCatalog (state, payload) {
        if (payload.status) {
            state.data.map(item => item.status = false)
        }

        state.data.unshift(payload)
    },
    updateStockCatalog (state, payload) {
        if (payload.status) {
            state.data.map(item => item.status = false)
        }

        let curSC = state.data.find(item => item.id === payload.id)

        curSC = payload
    },
    changeStockCatalogStatus (state, payload) {
        const curSC = state.data.find(item => item.id === payload.id)

        curSC.status = payload.status
    },
    deleteStockCatalog (state, payload) {
        state.data = state.data.filter(item => item.id !== payload.id)
    }
}

const actions = {}

const getters = {
    getStockCatalogs: state => state.data
}

export default {
    state,
    mutations,
    actions,
    getters
}
